import $ from 'jquery';

function beforeCache(context = document) {
  [...context.querySelectorAll('[tao-id]')].forEach((component) => {
    if (typeof component.beforeCache === 'function') {
      component.beforeCache.call(component);
    }
  });
}

$(() => {
  document.addEventListener('turbolinks:before-cache', beforeCache);
  window.tower.stack.on('pageunload', (event, $page) => beforeCache($page.get(0)));
});
